export const L10N = {
  ACTION_APPLY: { id: 'common.action.apply' },
  ACTION_SEARCH: { id: 'common.action.search', defaultMessage: '　　　' },

  LABEL_WHEN: { id: 'core.label.when', defaultMessage: '　　　' },
  LABEL_WHERE: { id: 'core.label.where', defaultMessage: '　　　　' },
  LABEL_WHERE_PLACEHOLDER: { id: 'common.label.select', defaultMessage: '　　　　　' },
};
